<template>
  <pnet-validation-observer>
    <div class="container">
      <div class="row" v-for="(rangeValue, index) in rangeValuesFlex" v-bind:key="index">

        <!-- label -->
        <label class="col" for
          v-if="(rangeValue.label !== undefined && !isEmptyOrSpaces(rangeValue.label)) ||
                (rangeValuesFlex[0].label !== undefined && !isEmptyOrSpaces(rangeValuesFlex[0].label))">
          <small>{{rangeValue.label}}</small>
        </label>

        <!-- from -->
        <div class="col" v-if="rangeValue.from !== undefined && rangeValue.fromSignLeft">
          <text-field v-model="rangeValue.fromSign"></text-field>
        </div>
        <div class="col" v-if="rangeValue.from !== undefined">
          <text-field v-model="rangeValue.from"></text-field>
        </div>
        <div class="col" v-if="rangeValue.from !== undefined && !rangeValue.fromSignLeft">
          <text-field v-model="rangeValue.fromSign"></text-field>
        </div>

        <!-- from-to operator -->
        <label for v-if="rangeValue.fromToOperator !== undefined">
          <small>{{rangeValue.fromToOperator}}</small>
        </label>

        <!-- to -->
        <div class="col" v-if="rangeValue.to !== undefined && rangeValue.toSignLeft" >
          <text-field v-model="rangeValue.toSign"></text-field>
        </div>
        <div class="col" v-if="rangeValue.to !== undefined">
          <text-field v-model="rangeValue.to"></text-field>
        </div>
        <div class="col" v-if="rangeValue.to !== undefined && !rangeValue.toSignLeft">
          <text-field v-model="rangeValue.toSign"></text-field>
        </div>

        <!-- to-value operator -->
        <label for v-if="rangeValue.toValueOperator !== undefined && showValue">
          <small>{{rangeValue.toValueOperator}}</small>
        </label>

        <!-- value -->
        <div class="col" v-if="rangeValue.valueSign !== undefined && rangeValue.valueSignLeft && showValue">
          <text-field v-model="rangeValue.valueSign"></text-field>
        </div>
        <div class="col" v-if="rangeValue.value !== undefined && showValue">
          <text-field v-model="rangeValue.value"></text-field>
        </div>
        <div class="col" v-if="rangeValue.valueSign !== undefined && !rangeValue.valueSignLeft && showValue">
          <text-field v-model="rangeValue.valueSign"></text-field>
        </div>

      </div>
      <div class="col-12 pt-3 pb-3">
        <div class="filtri mb-4">
          <div class="col-12 col-md-4 col-lg-12" align="right">
            <button class="btn btn-primary mt-4 p-1 pl-3 pr-3" v-on:click.prevent="inserisci">+</button>
            <button
              v-if="rangeValuesFlex.length > 1"
              class="btn btn-primary mt-4 p-1 pl-3 pr-3"
              v-on:click.prevent="cancella"
            >-</button>
          </div>
        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import TextField from "@/components/TextField.vue";
import { clone , equals } from "ramda";
export default Vue.extend({
  props: ["value",
    "label",
    "fromSign",
    "fromSignLeft",
    "toSign",
    "toSignLeft",
    "showValue",
    "valueSign",
    "valueSignLeft",
    "fromToOperator",
    "toValueOperator"],
  components: {
    TextField
  },
  data: function() {
    return {
      rangeValuesFlex: []
    }
  },
  methods: {
    inserisci: function() {
      this.rangeValuesFlex.push({
        order: this.rangeValuesFlex.length,
        label: this.rangeValuesFlex.length == 0 ? this.label : "",
        from: "",
        fromSign: this.fromSign,
        fromSignLeft: this.fromSignLeft,
        fromToOperator: this.fromToOperator,
        to: "",
        toSign: this.toSign,
        toSignLeft: this.toSignLeft,
        toValueOperator: this.toValueOperator,
        showValue: this.showValue,
        value: "",
        valueSign: this.valueSign,
        valueSignLeft: this.valueSignLeft,
      });
    },
    cancella: function() {
      this.rangeValuesFlex.pop();
    },
    isEmptyOrSpaces(str) {
      return str === null || str.match(/^ *$/) !== null;
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newVal, oldVal) {
        if (!equals(newVal,oldVal)) {
          Vue.set(this, 'rangeValuesFlex', clone(this.value));
        }
      }
    },
    rangeValuesFlex: {
      deep: true,
      handler(newVal, oldVal) {
        if (!equals(newVal, oldVal)) {
          this.$emit('input', this.rangeValuesFlex);
        }
      }
    }
  },
  mounted() {
    this.rangeValuesFlex = clone(this.value);
  },
});
</script>
